<ul class="sub-menu-v2 active">
    <app-sidebar2-checkbox
        *ngIf="quoteRequestStatuses?.length > 0"
        [statuses]="quoteRequestStatuses"
        [settingsFlag]="'NavigationV2QuoteRequests'"
        defaultRoute="/quoterequests/list"></app-sidebar2-checkbox>
</ul>
